module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/a-function.js
// module id = rRKF
// module chunks = 0